import { track as eventTrack } from "./EventTracker";
import { track as trackAdwordsConversion } from "./GoogleAdwords";
import { trackConversion as facebookTrackConversion } from "./Facebook";
import { trackConversion as experimentTrackConversion } from "./Experiments";
import { track as bingTrack } from "./Bing";
import { travelData } from "../state/travelData";
import { formatRangeToDE } from "@escapio/shared/l10n/date";

const EVENT_CATEGORY = "Preisvergleich Klick";
export const NEARBY_EVENT_ACTION_SUFFIX = " umliegend";

const formatRange = () =>
	formatRangeToDE(travelData.arrival, travelData.departure);

export const trackClickout = (
	origin,
	hotel,
	provider,
	providerName,
	price,
	position,
) => {
	const floored = Math.floor(price);
	const isNearby = hotel.distance !== -1;
	const eventAction = `${hotel.id} - ${hotel.name} - ${origin}${
		isNearby ? NEARBY_EVENT_ACTION_SUFFIX : ""
	}`;
	const eventLabel = [
		formatRange(),
		`${providerName}${
			provider.startsWith("KAYAK_") ? " (KAYAK)" : ""
		} - ${floored} ${travelData.currency}`,
		position,
	].join(" | ");

	experimentTrackConversion();
	eventTrack(EVENT_CATEGORY, eventAction, eventLabel);
	trackAdwordsConversion();
	bingTrack({ label: "Klickout" });
	facebookTrackConversion(hotel, floored);
};

export const trackDirectLink = (
	origin,
	hotel,
	position,
	isDirectLinkOnly = false,
) => {
	const isNearby = hotel.distance !== -1;
	const eventActions = [
		hotel.id,
		hotel.name,
		`${origin}${isNearby ? NEARBY_EVENT_ACTION_SUFFIX : ""}${
			isDirectLinkOnly ? " nur EDL" : ""
		}`,
		"Direktlink",
	];

	const eventLabels = travelData.hasDates ? [formatRange()] : ["Ohne Datum"];

	if (position !== undefined) {
		eventLabels.push(position);
	}

	experimentTrackConversion();
	eventTrack(
		"Preisvergleich Klick",
		eventActions.join(" - "),
		eventLabels.join(" | "),
	);

	bingTrack({ label: "Klickout" });
};
